import "./App.css";

import React from 'react';
import Adminuitable from "./components/Adminuitable";

function App() {
  return (
    <div className="App">
      <Adminuitable></Adminuitable>
    </div>
  );
}

export default App;
